RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ProgressBar = RivalIQ.views.ItemView.mixin({
        tagName: function () {
            const me = this;
            let tag = 'div';
            if (me.getOption('inline')) {
                tag = 'table';
            }
            return tag;
        },

        className: function () {
            const me = this;
            const classNames = ['progress-bar-item'];
            if (me.model.get('isMaximum')) {
                classNames.push('progress-bar-maximum');
            }
            return classNames.join(' ');
        },
        behaviors: {
            Information: {
                behaviorClass: RivalIQ.behaviors.Information
            }
        },

        getTemplate: function () {
            const me = this;
            let template = '#analyzeProgressBarTemplate';
            if (me.getOption('inline')) {
                template = '#analyzeProgressBarInlineTemplate';
            }
            return template;
        },

        serializeData: function () {
            const me = this;

            return _.defaults(me.model.toJSON(), {
                hideBar: false,
                showValue: true,
                headingClassName: '',
                barClassName: 'highlight-bg',
                title: '',
                formatter: _.identity
            });
        }
    });

    views.ProgressBars = Marionette.CollectionView.extend({
        childView: views.ProgressBar,
        childViewOptions: function () {
            const me = this;
            return {
                inline: me.getOption('inline')
            };
        }
    });

});
